import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-analysis",
  "use": "icon-analysis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-analysis\"><defs><style type=\"text/css\"></style></defs><path d=\"M532.16 144c41.92 0 75.84 33.92 75.84 75.84v440.32c0 41.92-33.92 75.84-75.84 75.84h-40.32c-41.856 0-75.84-33.92-75.84-75.84v-440.32c0-41.856 33.92-75.84 75.84-75.84h40.32z m256 112c41.92 0 75.84 33.92 75.84 75.84v328.32c0 41.92-33.92 75.84-75.84 75.84h-40.32c-41.856 0-75.84-33.92-75.84-75.84v-328.32c0-41.856 33.92-75.84 75.84-75.84h40.32z m-512 112c41.92 0 75.84 33.92 75.84 75.84v216.32c0 41.92-33.92 75.84-75.84 75.84h-40.32c-41.856 0-75.84-33.92-75.84-75.84v-216.32c0-41.856 33.92-75.84 75.84-75.84h40.32zM192 816h640c21.312 0 32 10.688 32 32 0 21.376-10.688 32-32 32H192c-21.312 0-32-10.624-32-32 0-21.312 10.688-32 32-32z\" p-id=\"2478\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/analysis.svg
// module id = /tUJ
// module chunks = 39